var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

var SvgClickSelector = function SvgClickSelector(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 9V6h6v3H4ZM2 5.5A1.5 1.5 0 0 1 3.5 4h7A1.5 1.5 0 0 1 12 5.5v4a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 2 9.5v-4Zm13.304 10.456a1 1 0 0 0 1.711.585l1.385-1.428 2.184 3.782a.997.997 0 0 0 1.727-.998l-2.184-3.782 1.919-.482a1 1 0 0 0 .346-1.778l-6.383-4.662c-.703-.514-1.68.054-1.584.918l.879 7.845ZM2 14.5A1.5 1.5 0 0 1 3.5 13h7a1.5 1.5 0 0 1 1.5 1.5v4a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 2 18.5v-4Z"
  })));
};

export default SvgClickSelector;